export function toSafeNumber(value: unknown, fallback = 0) {
  const numberValue = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(numberValue) ? numberValue : fallback;
}

export function formatSlotLabel(count: number) {
  const safeCount = Math.max(toSafeNumber(count), 0);
  const remainder100 = safeCount % 100;
  const remainder10 = safeCount % 10;

  if (remainder100 >= 11 && remainder100 <= 14) {
    return `${safeCount} слотов`;
  }

  if (remainder10 === 1) {
    return `${safeCount} слот`;
  }

  if (remainder10 >= 2 && remainder10 <= 4) {
    return `${safeCount} слота`;
  }

  return `${safeCount} слотов`;
}

export function getDevicesLimit(value: unknown) {
  return Math.max(toSafeNumber(value, 3), 0);
}

export function getFreeDeviceSlots(total: number, limit: number) {
  return Math.max(limit - total, 0);
}

export function getDeviceSlotsText(freeSlots: number) {
  if (freeSlots === 0) {
    return 'Все слоты для устройств заняты, удалите ненужное устройство';
  }

  return `Свободно еще ${formatSlotLabel(freeSlots)} для нового устройства.`;
}

export function createServerTilesWithPing<T extends { code: string; available: boolean }>(tiles: T[]) {
  return tiles.map((tile) => ({
    ...tile,
    ping: tile.code === 'WL' || !tile.available ? 'скоро' : `${Math.floor(Math.random() * 31) + 40} ms`,
  }));
}
